import {
    IconBone,
    IconCardio,
    IconCycling,
    IconGrupos,
    IconHiit,
    IconHome,
    IconMedic,
    IconNutricion,
    IconPilates,
    IconSesiones,
    IconTurco,
    IconVirtual,
    IconPt,
} from "assets/icons/config";

export const servicesMedicalSports = (brand, size = 24) => {
    return (
        [
            {
                icon: <IconHiit color={brand.color} size={size} />,
                text: "Entrenamiento funcional"
            },
            {
                icon: <IconCardio color={brand.color} size={size} />,
                text: "Entrenamiento cardiovascular"
            },
            {
                icon: <IconSesiones color={brand.color} size={size} />,
                text: "Zona de musculación"
            },
            {
                icon: <IconMedic color={brand.color} size={size} />,
                text: "Evaluación médica"
            },
            {
                icon: <IconTurco color={brand.color} size={size} />,
                text: "Zonas húmedas"
            },
            {
                icon: <IconGrupos color={brand.color} size={size} />,
                text: "Clases grupales"
            },
            {
                icon: <IconCycling color={brand.color} size={size} />,
                text: "Indoor cycling"
            }
        ]
    )
}

export const servicesComplementarySports = (brand, size = 24) => {
    return (
        [
            {
                icon: <IconBone color={brand.color} size={size} />,
                text: "Fisioterapia"
            },
            {
                icon: <IconPt color={brand.color} size={size} />,
                text: "Entrenamiento personalizado"
            },
            {
                icon: <IconNutricion color={brand.color} size={size} />,
                text: "Nutrición"
            },
            {
                icon: <IconPilates color={brand.color} size={size} />,
                text: "Pilates"
            },

        ]
    )
}

export const servicesVirtualSports = (brand, size = 24) => {
    return (
        [
            {
                icon: <IconNutricion color={brand.color} size={size} />,
                text: "Nutrición virtual"
            },
            {
                icon: <IconPt color={brand.color} size={size} />,
                text: "My Coach"
            },
            {
                icon: <IconVirtual color={brand.color} size={size} />,
                text: "BT@ Home"
            },
            {
                icon: <IconHome color={brand.color} size={size} />,
                text: "Personal Trainer online"
            },
        ]
    )
}

export function formatNumber(number) {
    return Math.round(number).toLocaleString('en-US');
}